export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8494.5ec64fe2.jpg";